import { GeoMeshData } from "../core/geoMeshData";
import { GeoPoint } from "../core/geoPoint";
import { GeoPolygonList } from "../core/geoPolygonList";
import { Continent } from "./continent";
import { Land } from "./land";
import { SubContinent } from "./subContinent";

export class Country extends Land {
    name: string;
    parentSubContinent: SubContinent;
    domainExtension: string;
    capitalPosition: GeoPoint;
    ldPolygons: GeoPolygonList;
    hdPolygons: GeoPolygonList;
    meshData: GeoMeshData;

    constructor() {
        super();
        this.defaultAltitude = 0.5;
    }

    get parentContinent(): Continent {
        return this.parentSubContinent.parentContinent;
    }

    get parent(): Land | null {
        return this.parentSubContinent;
    }

    get children(): Land[] {
        return [];
    }

    containsPoint(point: GeoPoint): boolean {
        return this.ldPolygons.containsPoint(point);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/model/country.ts